import React, { useEffect, useState } from 'react'
import { Document, Page, Text, View,Line , Font, StyleSheet, Image} from '@react-pdf/renderer'
import { fechaActual, HoraActual } from '../../../hooks/UseDate';
import { postInformacionEmpresa } from '../../../services/PaginaRuta';
import logo from '../../../images/Logo-G-Ocho.png'

// Registro de fuente personalizada
Font.register({
  family: 'Open Sans',
  fonts: [
    { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-regular.ttf' },
    { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-600.ttf', fontWeight: 600 }
  ]
})

const styles = StyleSheet.create({
  page: {
    padding: 10,
  },
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  column: {
    width: '50%',      
    fontSize: 10
  },
  bold:{
    fontFamily: 'Open Sans',
    fontWeight: 600
  },
  table: { 
    display: "table", 
    width: "auto", 
    borderStyle: "none",      
  }, 
  tableRow: {       
    flexDirection: "row" 
  },   
  tableCell: { 
    width: "10%",
    padding: '3px',      
    fontSize: 8 
  },  
  tableCellLarge:{
    width: "50%",
    padding: '3px',      
    fontSize: 8 
  }, 
  columnMedico:{
    width: '33.33%',      
    fontSize: 8
  },
  containerRecibeEntrega: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    //marginBottom: 10, // O cualquier valor que desees para el margen inferior
  },
  textIzquierda: {
    textAlign: 'left',
    // otros estilos para el texto izquierdo
  },
  textDerecha: {
    textAlign: 'right',
    // otros estilos para el texto derecho
  },
  image: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: 60, 
    height: 60, 
    margin: '10px',
  },
});


const ModalDescargarPDFSuministrosNoDespachadosQxFarmacia = ({nombreQuienRecibe,dataUser,dataSuministrosDespachados, dataSuministrosNoDespachados,dataSinContrato}) => {
  const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
  const [informacionEmpresa, setinformacionEmpresa]=useState([])
  useEffect(()=>{
    const datosEmpresa={
      "EMPCOD":usuarioInfo.Empresa,
      "MCDpto":usuarioInfo.Sede
  }
  postInformacionEmpresa(datosEmpresa).then((res)=>{
    setinformacionEmpresa(res.data[0]) 
  })
  },[])
  return (
    
        <Document>           
            <Page size='A4' style={{padding: '10px' }}>
              <View>
              <Image style={styles.image} src={logo} />
                <Text style={{ fontSize: 10,textAlign: 'center',padding: '3px'}}>{informacionEmpresa.EmpRazSoc}</Text>            
                <Text style={{ fontSize: 10,textAlign: 'center',padding: '3px'}}>{informacionEmpresa.EmpNit}</Text>
                <Text style={{textAlign: 'center' , fontSize: 10,padding: '3px'}}>DESPACHOS DE FARMACIA</Text>
                <Text style={{margin:'10px'}}></Text>
                <Text style={{fontSize: 8}}><Text style={styles.bold}>Fecha:</Text> {fechaActual()}</Text>
                <Text style={{fontSize: 8}}><Text style={styles.bold}>Hora:</Text> {HoraActual()}</Text>
                <Text style={{fontSize: 8}}><Text style={styles.bold}>Paciente:</Text> {dataUser.MPNOMC? dataUser.MPNOMC.trim():null} - {dataUser.MPCedu}</Text>
                <Text style={{fontSize: 8}}><Text style={styles.bold}>PAQUETE QX</Text> {dataUser.PaqCod} - {dataUser.PaqDes? dataUser.PaqDes.trim():null}</Text>
                <Text style={{borderBottomWidth: 1, borderBottomColor: 'black',  marginBottom: 5, marginTop:5}}/>
                <View  style={styles.table}>
                <View style={styles.tableRow}>
                    <View style={styles.tableCell}>
                        <Text  style={styles.bold}>Código</Text> 
                    </View>
                    <View style={styles.tableCellLarge}> 
                        <Text  style={styles.bold}>Descripción</Text> 
                  </View> 
                  <View style={styles.tableCell}> 
                    <Text  style={styles.bold}>Hora/Fecha Despacho</Text> 
                  </View> 
                  <View style={styles.tableCell}> 
                    <Text  style={styles.bold}>Est Dsp</Text> 
                  </View> 
                  <View style={styles.tableCell}> 
                    <Text  style={styles.bold}>Cantidad ordenada</Text> 
                  </View>
                  <View style={styles.tableCell}> 
                    <Text  style={styles.bold}>Cantidad despachada</Text> 
                  </View>
                  
                </View>
                 { 
                 dataSuministrosDespachados.length !== 0?
                     dataSuministrosDespachados.map((item,index)=>( 
                        <View key={index}>
                        <Text style={{borderBottomWidth: 1, borderBottomColor: 'black',  marginBottom: 2, marginTop:2}}/>
                        <View style={styles.tableRow}  >
                            <View style={styles.tableCell}> 
                                <Text >{item.MSRESO? item.MSRESO.trim():null}</Text> 
                            </View> 
                            <View style={styles.tableCellLarge}> 
                                <Text >{item.MSNomG?item.MSNomG.trim():null}</Text>                                 
                            </View> 
                            <View style={styles.tableCell}> 
                                <Text >{fechaActual()} {HoraActual()}</Text> 
                            </View> 
                            <View style={styles.tableCell}> 
                                {/* <Text >{estadoDespacho? (estadoDespacho === 'P' || estadoDespacho === 'C'? 'NO':'SI'):null}</Text>  */}
                                <Text >SI</Text>
                            </View>     
                            <View style={styles.tableCell}> 
                                <Text >{item.PQCaSuSl? item.PQCaSuSl:null}</Text> 
                            </View>        
                            <View style={styles.tableCell}> 
                            <Text >{item.PQCaSuSl? item.PQCaSuSl:null}</Text> 
                            </View>                   
                        </View>
                        {/* <View style={styles.container}>
                          <View style={styles.columnMedico}>
                            <Text><Text style={styles.bold}>Concentración:</Text> {item.caracteristicasSuministros[0].CncDes?item.caracteristicasSuministros[0].CncDes.trim():null}</Text>                          
                          </View>
                          <View style={styles.columnMedico}>
                            <Text><Text style={styles.bold}>Forma:</Text> {item.caracteristicasSuministros[0].FSmDscUMd?item.caracteristicasSuministros[0].FSmDscUMd.trim():null}</Text>
                          </View>
                          <View style={styles.columnMedico}>
                            <Text><Text style={styles.bold}>Marca:</Text> {item.caracteristicasSuministros[0].MarDsc?item.caracteristicasSuministros[0].MarDsc.trim():null}</Text>                          
                          </View>
                        </View> */}
                        </View>
                     ))
                     :
                     null 
                 } 

                 {
                  dataSinContrato.length !== 0?
                  dataSinContrato.map((item,index)=>(
                    <Text style={{fontSize: 8}} key={index}>{'\n'}* {item.mensaje? item.mensaje.trim() : null}</Text>
                  ))
                  :
                  null
                 }
        </View>
                {/* {dataSuministrosDespachados.map((itemSuministro )=> ( */}
                  
                      {/* // <Text style={{fontSize: 8}}>{'\n'}* Para el paquete {itemSuministro.PaqCod? itemSuministro.PaqCod.trim():null}, fue desachapo el Suministro {itemSuministro.MSRESO? itemSuministro.MSRESO.trim() : null} con el nombre {itemSuministro.MSNomG? itemSuministro.MSNomG.trim():null} y la Cantidad despachada {itemSuministro.PQCaSuSl? itemSuministro.PQCaSuSl:null} para el paciente  {dataUser.MPTDoc?dataUser.MPTDoc.trim():null}-{dataUser.MPCedu? dataUser.MPCedu.trim():null} {dataUser.MPNOMC?dataUser.MPNOMC.trim():null}</Text> */}
                      
                {/* )) */}
                {/* } */}
                 {
                  dataSuministrosDespachados.length !== 0?
                  <Text>
                <Text style={{borderBottomWidth: 1, borderBottomColor: 'black',  marginBottom: 5, marginTop:5}}/>
                 <Text style={{fontSize: 8}}>PAQUETE QX {dataUser.PaqCod}</Text>
                <Text style={{fontSize: 8,textAlign: 'center'}}>{nombreQuienRecibe}</Text>
                <Text style={{fontSize: 8,textAlign: 'center'}}>Quien Recibe</Text>
                </Text>
                :
                null
                }
                <Text style={{fontSize: 8,textAlign: 'center'}}>* * * FIN DEL REPORTE * * *</Text>
              </View>
            </Page>
            {
              dataSuministrosNoDespachados.length !== 0?
            <Page size='A4' style={{padding: '50px' }}>
              <View>
              <Text style={{ fontSize: 10,textAlign: 'center',padding: '3px'}}>{informacionEmpresa.EmpRazSoc}</Text>            
                <Text style={{ fontSize: 10,textAlign: 'center',padding: '3px'}}>{informacionEmpresa.EmpNit}</Text>
              <Text style={{textAlign: 'center',fontSize: 9 }}>NO FUERON DESPACHOS DE FARMACIA</Text>
                <Text><br /></Text>
                <Text style={{fontSize: 8}}>Fecha: {fechaActual()}</Text>
                <Text style={{fontSize: 8}}>Hora: {HoraActual()}</Text>
                <Text style={{fontSize: 8}}>Paciente: {dataUser.MPNOMC? dataUser.MPNOMC.trim():null} - {dataUser.MPCedu}</Text>
                <Text style={{fontSize: 8}}>PAQUETE QX {dataUser.PaqCod} - {dataUser.PaqDes? dataUser.PaqDes.trim():null}</Text>
                {dataSuministrosNoDespachados.map((itemSuministro,index )=> (                  
                      <Text style={{fontSize: 8}} key={index}>{'\n'}* Para el Paquete Qx {itemSuministro.PaqCod?itemSuministro.PaqCod.trim():null}, Suministro {itemSuministro.MSRESO?itemSuministro.MSRESO.trim():null} con el nombre {itemSuministro.MSNomG?itemSuministro.MSNomG.trim():null} del paciente {dataUser.MPTDoc?dataUser.MPTDoc.trim():null}-{dataUser.MPCedu?dataUser.MPCedu.trim():null} {dataUser.MPNOMC?dataUser.MPNOMC.trim():null}, El suministro se encuentra inactivo en el paquete, éste no será despachado.</Text>
                      
                ))
                }
                
              </View>
            </Page>
            :
            null
            }
            
              
        </Document>        
     
    
  )
}

export default ModalDescargarPDFSuministrosNoDespachadosQxFarmacia;






























// const MyDocument = () => (

//     <Document>
//       <Page>
//         <h1>My PDF Document</h1>
//       </Page>
//     </Document>
//   );
  
//   const ModalDescargarPDFSuministrosNoDespachadosQxFarmacia = () => (
//     // <form>
//     <PDFDownloadLink document={<MyDocument />} fileName="my_document.pdf">
//       <button type="submit">Download PDF</button>
//     </PDFDownloadLink>
//     // {/* </form> */}
//   );
  
//   export default ModalDescargarPDFSuministrosNoDespachadosQxFarmacia;

// const MyDocument = () => (
//   <Document>
//     <Page>
//       <h1>My PDF Document</h1>
//     </Page>
//   </Document>
// );

// const ModalDescargarPDFSuministrosNoDespachadosQxFarmacia = () => {
//   const handleSubmit = (event) => {
//     event.preventDefault();
//     // Aquí puedes agregar cualquier lógica adicional antes de la descarga del archivo PDF
//   }

//   return (
//     <form onSubmit={handleSubmit}>
//       <PDFDownloadLink document={<MyDocument />} fileName="my_document.pdf">
//         {({ blob, url, loading, error }) =>
//           loading ? 'Loading document...' : <button type="submit">Download PDF</button>
//         }
//       </PDFDownloadLink>
//     </form>
//   );
// };

// export default ModalDescargarPDFSuministrosNoDespachadosQxFarmacia;





























